import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// 🚀 Siempre hacemos bootstrap (SPA).
if (!environment.isWebComponent) {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch(err => console.error(err));
} else {
  /**
   * Función que inicia el bootstrap de Angular Elements y devuelve
   * la promesa que se resuelve con el Custom Element Class.
   * Esta función es la que exportaremos.
   */
  (window as any).initBelenderComponent = async () => {
      // Si ya fue inicializado, devuelve la clase ya generada.
      if ((window as any).BelenderWebComponent) {
          return (window as any).BelenderWebComponent;
      }

      // Ejecuta el bootstrap del módulo.
      const moduleRef = await platformBrowserDynamic().bootstrapModule(AppModule);

      // Espera a que el AppModule haya generado la clase.
      // La clase se genera en el constructor de AppModule (ver paso 2).
      const customElementClass = (window as any).BelenderWebComponent;

      if (!customElementClass) {
          throw new Error("La clase BelenderWebComponent no fue generada por AppModule. Revisar la lógica de createCustomElement.");
      }
      return customElementClass;
  };
  }

    